import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

interface FarmerRouteProps {
  children: React.ReactNode;
}

const FarmerRoute: React.FC<FarmerRouteProps> = ({ children }) => {
  const { user, isAuthenticated } = useAuth();

  if (!isAuthenticated || user?.role !== 'farmer') {
    // Redirect to marketplace if not authenticated or not a farmer
    return <Navigate to="/marketplace" replace />;
  }

  return <>{children}</>;
};

export default FarmerRoute;